import { useMemo } from 'react';

import type {
  Team,
  AuthorizationState,
} from 'components/common/Authorization/types';
import { useAuthorizationLogic } from 'components/common/Authorization/useAuthorizationLogic';

interface UseProtectedRouteLogicParams {
  requiredPermission: string;
  team?: Team | null;
  signalsResource?: boolean;
  isLoading?: boolean;
  teamPermission?: string;
  allowEither?: boolean;
}

interface ProtectedRouteState extends AuthorizationState {
  shouldRedirect: boolean;
}

export const useProtectedRouteLogic = ({
  requiredPermission,
  team = null,
  signalsResource = false,
  isLoading: additionalLoading = false,
  teamPermission,
  allowEither = false,
}: UseProtectedRouteLogicParams): ProtectedRouteState => {
  const authState = useAuthorizationLogic({
    requiredPermission,
    team,
    signalsResource,
    teamPermission,
    allowEither,
  });

  return useMemo(() => {
    const isLoading = authState.isLoading || additionalLoading;
    const shouldRedirect = !isLoading && !authState.isAuthorized;

    return {
      ...authState,
      isLoading,
      shouldRedirect,
    };
  }, [authState, additionalLoading]);
};
